import { render, staticRenderFns } from "./SupplierIndex.vue?vue&type=template&id=462b7048&scoped=true&"
import script from "./SupplierIndex.vue?vue&type=script&lang=js&"
export * from "./SupplierIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b7048",
  null
  
)

export default component.exports